/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'sysque-text-area-description',
  templateUrl: './sysque-text-area-description.component.html',
  styleUrls: ['./sysque-text-area-description.component.scss'],
  standalone: false
})
export class SysqueTextBoxDescriptionComponent {
  @Input() label: string;
  @Input() description: string;
  @Input() width: string;
  @Input() height: string = '52px';
  @Output() valueChanged: EventEmitter<string> = new EventEmitter<string>();

  public onValueChanged($event: string): void {
    this.valueChanged.emit($event);
  }
}
